
import { AxiosInstance } from "./auth/AxiosInstance";

export const getCategories = async () => {
    const response = await AxiosInstance.get('/categories');
    return response.data;
};

export const getTags = async () => {
    const response = await AxiosInstance.get('/tags');
    return response.data;
};

export const createCategory = async (data) => {
    const response = await AxiosInstance.post('/categories', data);
    return response.data;
};

export const createTag = async (name) => {
    const response = await AxiosInstance.post('/tags', { name });
    return response.data;
};
